import React, { useEffect, useState } from "react";
// @ts-ignore
import XMLParser from 'react-xml-parser'
import { Anchor, Box, Group, Text, Title } from "@mantine/core";
import dayjs from "dayjs";

interface InformationDetails {
  title: string
  link: string
  pubDate: string
}

const Information: React.FC = () => {
  const [information, setInformation] = useState<Array<InformationDetails>>([])
  const [informationError, setInformationError] = useState(false)

  useEffect(() => {
    fetch('https://www.creativehope.co.jp/invyinformation/rss.xml', {
      mode: 'cors',
    })
      .then((response) => {
        if (!response.ok) throw new Error(`RSS取得に失敗しました: ${response.status}`)
        return response.text()
      })
      .then((data) => {
        const xml = new XMLParser().parseFromString(data)

        // channel 直下の metadata 要素数に依存しないよう、item 要素のみを抽出する
        const informationList = xml.children[0].children.filter(
          (child: any) => child.name === 'item'
        )
        const infoShortened = informationList.slice(0, 5)
        let arr = []
        for (let i = 0; i < infoShortened.length; i++) {
          let innerArr = setDetails(infoShortened[i]['children'])
          arr.push(innerArr)
        }
        setInformation(arr)
      })
      .catch((e) => {
        console.error('お知らせの取得に失敗しました', e)
        setInformationError(true)
      })
  }, [])

  const setDetails = (arr: any): InformationDetails => {
    let info: Record<string, string> = {}
    for (let i = 0; i < arr.length; i++) {
      info[arr[i]['name']] = arr[i]['value']
    }
    return info as unknown as InformationDetails
  }

  return (
    <Box>
      <Title size={16} mb={16}>お知らせ</Title>
      <Group display="grid" gap={8}>
        {informationError && (
          <Text fz={13} c="red">お知らせを取得できませんでした</Text>
        )}
        {information.map((info) => (
          <Text fz={13} fw={400} my={4} key={info.link}>
            {dayjs(info.pubDate).format('YYYY/MM/DD')}
            <Anchor href={info.link} target="_blank" rel="noopener noreferrer" fz={13} ml={24}>
              {info.title}
            </Anchor>
          </Text>
        ))}
      </Group>
    </Box>
  )
}

export default Information
